import { Stack, Typography } from "@mui/material";

const RoleWrapper = ({ children, title }) => {
  return (
    <Stack
      justifyContent="space-between"
      alignItems="center"
      bgcolor="grey.gb"
      p={1}
      sx={{ borderRadius: 1 }}
      direction="row"
    >
      <Typography variant="body2">{title}</Typography>
      <Stack direction="row" spacing={1}>
        {children}
      </Stack>
    </Stack>
  );
};

export default RoleWrapper;
